namespace SPA
{
	export namespace LRM
	{

		export class LRMTableModel
			extends ui.table.model.AbstractTableModel<Wollmilch.LandMapRegion.ILRMObject>
		{

			public constructor()
			{
				super();

				this.ModelReader( new LRMTableDataReader() );
			}

			public buildHeader(): JQuery<HTMLElement>
			{
				return new ui.base.BaseHTMLElement( 'tr' )
					.append( new ui.base.BaseHTMLElement( 'th' ) )
					.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'LandRegionMap.TITLE.LIST.LONG.object_number' ) ) )
					.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'LandRegionMap.TITLE.LIST.LONG.address' ) ) )
					.append( new ui.base.BaseHTMLElement( 'th' ).append( app.getMessage( 'LandRegionMap.TITLE.LIST.LONG.progress' ) ).attr( 'colspan', '2' ) )
					.append( new ui.base.BaseHTMLElement( 'th' ) )
				.Root();
			}

		}

		export class LRMTableDataReader
			extends ui.table.DataReader<Wollmilch.LandMapRegion.ILRMObject>
		{

			public constructor()
			{
				super();
			}

			public GenerateDataField( p_Data: Wollmilch.LandMapRegion.ILRMObject, index: number ): JQuery
			{
				const width	= ( p_Data.State === 'PENDING' ? 20 : ( p_Data.State === 'TRANSMITTED' ? 40 : ( p_Data.State === 'PROCESSING' ? 60 : 100 ) ) );
				let cntxt	= 'success';

				if ( width < 80 ) {	cntxt	= 'info'; }
				if ( width < 50 ) {	cntxt	= 'warning'; }
				if ( width < 25 ) {	cntxt	= 'danger'; }

				return new ui.base.BaseHTMLElement( 'tr' )
					.append(
						new ui.base.BaseHTMLElement( 'td' )
					)
					.append(
						new ui.base.BaseHTMLElement( 'td' ).append(
							ui.$$.a().text( p_Data.ObjectNumber ).css( 'cursor', 'pointer' ).on(
								'click',
								() =>
								{
									app.getGlobalTabControl().addTab(
										p_Data.ObjectNumber,
										new SPA.LRM.Page( new Wollmilch.LandMapRegion.LRMObject( p_Data ) ),
										true
									);
								}
							)
						)
					)
					.append(
						new ui.base.BaseHTMLElement( 'td' ).append( SPA.gui.Address.PostalAddressNormalized( p_Data.Object.Address ) )
					)
					.append(
						new ui.base.BaseHTMLElement( 'td' ).append(
							ui.$$.p().text( app.getMessage( 'LandRegionMap.STATE.' + p_Data.State ) ).addClass( 'text-' + cntxt )
						)
					)
					.append(
						new ui.base.BaseHTMLElement( 'td' ).css( 'min-width', '150px' ).append(
							new ui.base.BaseHTMLElement( 'div' )
								.addClass( 'progress' )
								.append(
									new ui.base.BaseHTMLElement( 'div' )
									.addClass( 'progress-bar progress-bar-' + cntxt + ' progress-bar-striped active' )
									.css(
										{
											width: width + '%'
										}
									)
								)
						)
					)
					.append(
						// Aktionsbuttons oder so!!!
						new ui.base.BaseHTMLElement( 'td' ).append(
							$( new Button(
									{
										title: app.getSpanMessage( 'Aux.OPEN_BTN' ),
										style: 'default',
										size: 'xs',
										on:
										{
											click: () =>
											{
												app.getGlobalTabControl().addTab(
													p_Data.ObjectNumber,
													new SPA.LRM.Page( new Wollmilch.LandMapRegion.LRMObject( p_Data ) ),
													true
												);
											}
										}
									}
								).getElement()
							)
						)
					)
				.Root();
			}

		}

	}
}
